// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Article_Article__4bJgI {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}
.Article_ArticleContent__7R02V {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 2rem;
    /* font-family: Rufina, sans-serif; */
    font-size: 1rem;
    color: #0a2945;
    max-width: 800px;
}

.Article_ArticleContent__7R02V h3 {
    width: 100%;
    text-align: left;
    font-size: 22px;
}
.Article_ArticleContent__7R02V h1 {
    font-size: 2rem;
    font-weight: 700;
}
.Article_ArticleContent__7R02V p {
    font-size: 18px;
    font-weight: 400;
}

.Article_ArticleContent__7R02V img {
    width: 100%;
}

.Article_ArticleContent__7R02V ul li {
    font-weight: 500;
    margin: 1rem;
    font-size: 16px;
    line-height: 1.5;
}

.Article_ArticleContent__7R02V span {
    font-weight: 700;
    font-size: 20px;
}

.Article_ArticleByLine__mll4w {
    width: 100%;
    text-align: right;
    font-size: 0.85rem;
}

@media screen and (max-width: 450px) {
   
    .Article_ArticleContent__7R02V ol {
        margin: 0;
        padding: 0;
    }
    .Article_ArticleContent__7R02V ul {
        margin: 0;
        padding: 0;
    }
}
@media screen and (max-width: 768px) {
    .Article_ArticleContent__7R02V h1 {
        font-size: 1.3rem;
    }
    .Article_ArticleContent__7R02V p {
        font-size: 14px;
    }
    .Article_ArticleContent__7R02V span {
        font-size: 16px;
    }
    .Article_ArticleContent__7R02V ul li {
        font-size: 12px;
    }
    .Article_ArticleContent__7R02V h3 {
        font-size: 1rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Blog/Article.module.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,qCAAqC;IACrC,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI;QACI,SAAS;QACT,UAAU;IACd;IACA;QACI,SAAS;QACT,UAAU;IACd;AACJ;AACA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["\n.Article {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n}\n.ArticleContent {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 2rem;\n    /* font-family: Rufina, sans-serif; */\n    font-size: 1rem;\n    color: #0a2945;\n    max-width: 800px;\n}\n\n.ArticleContent h3 {\n    width: 100%;\n    text-align: left;\n    font-size: 22px;\n}\n.ArticleContent h1 {\n    font-size: 2rem;\n    font-weight: 700;\n}\n.ArticleContent p {\n    font-size: 18px;\n    font-weight: 400;\n}\n\n.ArticleContent img {\n    width: 100%;\n}\n\n.ArticleContent ul li {\n    font-weight: 500;\n    margin: 1rem;\n    font-size: 16px;\n    line-height: 1.5;\n}\n\n.ArticleContent span {\n    font-weight: 700;\n    font-size: 20px;\n}\n\n.ArticleByLine {\n    width: 100%;\n    text-align: right;\n    font-size: 0.85rem;\n}\n\n@media screen and (max-width: 450px) {\n   \n    .ArticleContent ol {\n        margin: 0;\n        padding: 0;\n    }\n    .ArticleContent ul {\n        margin: 0;\n        padding: 0;\n    }\n}\n@media screen and (max-width: 768px) {\n    .ArticleContent h1 {\n        font-size: 1.3rem;\n    }\n    .ArticleContent p {\n        font-size: 14px;\n    }\n    .ArticleContent span {\n        font-size: 16px;\n    }\n    .ArticleContent ul li {\n        font-size: 12px;\n    }\n    .ArticleContent h3 {\n        font-size: 1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Article": `Article_Article__4bJgI`,
	"ArticleContent": `Article_ArticleContent__7R02V`,
	"ArticleByLine": `Article_ArticleByLine__mll4w`
};
export default ___CSS_LOADER_EXPORT___;
